import { Center, Image } from "@chakra-ui/react";
import { LazyLoadImage } from "react-lazy-load-image-component";

// Redux.
import { useSelector } from "react-redux";
import { isGalleriaImgActive } from "app/master-paln-img/master-plan-img.slice";

// Stylings
import externalStyles from "./ZoneImage.module.css";

// Images
import idleZoneImage from "img/Mastr--Sun-Capital.jpg";
import activeZoneImage from "img/Master-Plan-Fanal-Sun-Capital.jpg";

// Utils
export default function ZoneImage() {
  const isSunCapitalActive = useSelector(isGalleriaImgActive);

  return (
    <Center w="full" h="full">
      <Image
        className={externalStyles.zone_image}
        as={LazyLoadImage}
        borderRadius={{
          base: "1.5rem",
          mobile8: "2.5rem",
          mobile13: "3rem",
          tablet13: "4rem",
          tablet16: "3rem",
        }}
        w="full"
        h="full"
        src={isSunCapitalActive ? activeZoneImage : idleZoneImage}
      />
    </Center>
  );
}
